import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { pickerOptions } from 'utils/pickerOptions';
import ImagePicker, { ImagePickerResponse } from 'react-native-image-picker';
import { UAlert, uploadFile } from 'utils';
import { ImageButton } from './ImageButton';

export const ImageUpload = ({
  insertImages,
  noText,
  onSelect,
}: {
  insertImages: (image: string) => any;
  noText: boolean;
  onSelect?: () => any;
}): JSX.Element => {
  const [uploading, setUploading] = useState(false);
  const [image, setImage] = useState('');

  const uploadImage = async () => {
    try {
      const res = await chooseImage();
      if (!res) return setUploading(false);
      setUploading(true);
      onSelect && onSelect();
      const url = await uploadFile(
        `data:${res.type};base64,${res.data}`,
        res.type || '',
        res.uri
      );

      setImage(url);
      insertImages(`![your image will appear here](${url})`);
      setUploading(false);
    } catch (err) {
      UAlert(err.message);
      setUploading(false);
    }
  };

  return (
    <TouchableOpacity onPress={uploadImage}>
      <ImageButton noText={noText} uploading={uploading} />
    </TouchableOpacity>
  );
};

const chooseImage = (): Promise<ImagePickerResponse | null> =>
  new Promise((resolve, reject) => {
    ImagePicker.showImagePicker(
      { ...pickerOptions, title: 'Pick an image to upload' },
      (res) => {
        if (res.didCancel) {
          resolve(null);
        } else if (res.error) {
          reject(new Error(res.error));
        } else if (res.customButton) {
          reject(new Error(res.customButton));
        } else {
          resolve(res);
        }
      }
    );
  });
